import $ from 'jquery';

(function () {
    "use strict";

    function _setup_outbound_target() {
        $.each($('a'), function(i, v) {
            if (v.hostname && v.hostname !== '#' && v.hostname !== window.location.hostname) {
                $(v).attr('target', '_blank');
            }
        });
    }

    $(function() {
        _setup_outbound_target();

        // track outbound links
        $('a').click(COLDCREEK.google.trackOutbound);
    });
})();



// WEBPACK FOOTER //
// ./assets/js/coldcreek.js